<template>
  <b-card class="text-center">
    <p>You have not created any quizzes yet.</p>
    <p>
      Click on
      <router-link to="/host/new" class="mr-2">New Quiz</router-link>in the
      bottom navigation to do so.
    </p>
  </b-card>
</template>

<script>
export default {
  name: "HostNoQuizInfo"
};
</script>
